import { Loader2 } from "lucide-react";

export const Loader = ({ label = "Loading" }) => (
  <div data-testid="page-loader" className="min-h-[60vh] flex flex-col items-center justify-center gap-3 text-ash">
    <Loader2 className="animate-spin" size={26} />
    <span className="text-sm tracking-wide">{label}…</span>
  </div>
);

export default Loader;
